import { render, staticRenderFns } from "./project-menu-flags.vue?vue&type=template&id=f4a5bafa&scoped=true&"
import script from "./project-menu-flags.component.ts?vue&type=script&lang=ts&"
export * from "./project-menu-flags.component.ts?vue&type=script&lang=ts&"
import style0 from "./project-menu-flags.vue?vue&type=style&index=0&id=f4a5bafa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a5bafa",
  null
  
)

export default component.exports